var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "text",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 227.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.65,67.76v62.08c-4.03-2.28-7.71-3.42-11.01-3.42-10.55,0-15.83,8.07-15.83,24.21v73.4H-.22v-84.58c0-22.35,6.1-40.16,18.3-53.46,12.2-13.29,28.5-19.94,48.89-19.94,4.54,0,10.44.57,17.68,1.7Z",
    fill: "#1a232d",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.62,69.31v154.72h-58.03V69.31h58.03ZM134.76.26c7.85,0,14.66,2.77,20.41,8.3,5.73,5.53,8.61,12.08,8.61,19.63,0,8.07-2.71,14.69-8.14,19.86-5.44,5.18-12.4,7.76-20.87,7.76s-15.45-2.59-20.87-7.76c-5.44-5.17-8.16-11.79-8.16-19.86,0-7.55,2.87-14.1,8.62-19.63C120.09,3.03,126.89.26,134.76.26Z",
    fill: "#1a232d",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M322.81,224.03h-58.04v-87.37c0-8.9-3.68-13.34-11.01-13.34s-10.87,4.45-10.87,13.34v87.37h-58.03v-86.29c0-20.17,6.66-37.16,20.01-50.98,13.36-13.81,29.7-20.71,49.04-20.71,22.14,0,39.88,8.02,53.24,24.05,10.44,12.52,15.67,29.95,15.67,52.3v81.63Z",
    fill: "#1a232d",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M426.76,66.05c21.93,0,40.73,7.89,56.41,23.67,15.69,15.78,23.52,34.68,23.52,56.72s-7.95,41.39-23.83,57.1c-15.88,15.73-35.05,23.59-57.5,23.59s-41.63-7.89-57.58-23.67c-15.93-15.78-23.89-34.79-23.89-57.03s7.96-41.72,23.89-57.18c15.94-15.47,35.6-23.2,58.97-23.2ZM425.2,123.32c-6.2,0-11.48,2.25-15.82,6.75-4.35,4.5-6.52,10-6.52,16.52s2.2,11.9,6.58,16.45c4.4,4.55,9.65,6.83,15.75,6.83s11.51-2.28,15.91-6.83c4.4-4.55,6.6-10.04,6.6-16.45s-2.17-12.03-6.52-16.52c-4.35-4.5-9.68-6.75-15.99-6.75Z",
    fill: "#1a232d",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M643.52,69.31l-72.32,160.77-71.39-160.77h55.39l16.46,41.75,18-41.75h53.85Z",
    fill: "#1a232d",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M719.65,66.05c21.93,0,40.73,7.89,56.41,23.67,15.69,15.78,23.52,34.68,23.52,56.72s-7.95,41.39-23.83,57.1c-15.88,15.73-35.05,23.59-57.5,23.59s-41.63-7.89-57.58-23.67c-15.93-15.78-23.89-34.79-23.89-57.03s7.96-41.72,23.89-57.18c15.94-15.47,35.6-23.2,58.97-23.2ZM718.1,123.32c-6.2,0-11.48,2.25-15.82,6.75-4.35,4.5-6.52,10-6.52,16.52s2.2,11.9,6.58,16.45c4.4,4.55,9.65,6.83,15.75,6.83s11.51-2.28,15.91-6.83c4.4-4.55,6.6-10.04,6.6-16.45s-2.17-12.03-6.52-16.52c-4.35-4.5-9.68-6.75-15.99-6.75Z",
    fill: "#1a232d",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameLogo);
export default __webpack_public_path__ + "static/media/name_logo.2fa9b60f9b1c9164c49c15c3e5348dd1.svg";
export { ForwardRef as ReactComponent };